(ns quuppa.qsm.routing
  (:require [reitit.frontend :as reitit]
            [reitit.coercion.malli :as rcm]
            [malli.util :as mu]
            [quuppa.peweb.peinfo-logs :as peinfo-logs]
            [quuppa.peweb.peinfo-locators :as peinfo-locators]
            [quuppa.peweb.peinfo-tags :as peinfo-tags]
            [quuppa.qsm.users.view :as qsm-users]
            [quuppa.qsm.view :as view]
            [quuppa.qsm.api-keys.view :as api-keys]
            [quuppa.qsm.cors.view :as cors]
            [quuppa.qsm.not-found :as not-found]
            [quuppa.qsm.planner.view :as planner]
            [quuppa.qsm.projects.view :as projects]
            [quuppa.qsm.projects.project-view :as project]
            [quuppa.qsm.site.view :as site]
            [quuppa.qsm.qpes.view :as qpes]
            [quuppa.qsm.qpes.qpe-view :as qpe]
            [quuppa.qsm.api-docs.view :as api-docs]
            [quuppa.qsm.signin.view :as sigin]
            [quuppa.peweb.mapview-events :as mapview-events]
            [quuppa.qsm.dashboard.view :as dashboard]
            quuppa.routing))

(def qpe-path-schema
  [:map
   [:qpe-identity :string]])

(def routes
  (reitit/router
    [["/"
      ;; This controller loads :authorized-qpes, qpe-details might also
      ;; depend on this data currently.
      {:controllers [view/root-controller]
       :view not-found/not-found-view}

      [""
       {:controllers [projects/projects-controller]}

       [""
        {:view projects/projects-page
         :controllers [projects/projects-list-controller]
         :name :projects}]

       ["dashboard"
        {:view dashboard/dashboard
         :controllers [dashboard/dashboard-controller]
         :name :dashboard}
        [""
         {:name :dashboard
          :dashboard-tab :available-projects}]
        ["/:dashboard-tab"
         {:name :dashboard-tab
          :parameters {:path [:map [:dashboard-tab :keyword]]}}]]

       ["projects/:project-id"
        {:controllers [project/project-controller]
         :app-nav-page :project
         :parameters {:path [:map [:project-id :string]]}}
        [""
         {:view project/project-page
          :name :project}]
        ["/sites/:site-id"
         {:view site/site-page
          :controllers [site/site-controller
                        site/site-view-tabs-controller]
          :parameters {:path ^:replace
                       [:map
                        [:project-id :string]
                        [:site-id :string]]}}
         [""
          {:name :site
           :qpe-info-tab :site-plan}]
         ["/info/site-plan"
          {:name :site-plan
           :qpe-details-id :qpe-info
           :qpe-info-tab :site-plan}]
         ["/info/engine"
          {:name :site-engine
           :qpe-details-id :qpe-info
           :qpe-info-tab :engine}]
         ["/info/engine/configuration"
          {:name :site-engine-configuration
           :qpe-details-id :qpe-info
           :qpe-info-tab :engine}]
         ["/info/locators"
          {:name :site-info-locators
           :qpe-details-id :qpe-info
           :qpe-info-tab :locators
           :parameters {:query peinfo-locators/table-query-params}
           :controllers [site/locators-controller]}]
         ["/info/tags"
          {:name :site-info-tags
           :qpe-details-id :qpe-info
           :qpe-info-tab :tags
           :parameters {:query peinfo-tags/query-params}
           :controllers [site/tag-controller]}]
         ["/info/log"
          {:controllers [site/logs-controller]
           :qpe-info-tab :log}
          [""
           {:name :site-info-log
            :qpe-info-tab :log}]
          ["/:log-type"
           {:name :site-info-log-type
            ;; Manually merge, as Reitit doesn't yet know how to merge Malli schema.
            :parameters {:path ^:replace [:map
                                          [:project-id :string]
                                          [:site-id :string]
                                          [:log-type :keyword]]}}]]

         ["/info/map"
          {:name :site-info-map
           :qpe-info-tab :map
           :controllers [site/tag-controller]
           ;; Manually merge, as Reitit doesn't yet know how to merge Malli schema.
           :parameters {:query (mu/merge mapview-events/query-parameters
                                         peinfo-locators/query-params)}}]
         ["/api"
          {:name :site-api
           :qpe-info-tab :api
           :controllers [api-keys/controller
                         cors/controller]}]
         ["/api-docs"
          {:name :site-api-docs
           :qpe-info-tab :api-docs
           :controllers []}]]]]

      ["qpes"
       {:view qpes/qpes-page
        :controllers [qpes/qpes-controller]
        :name :qpes
        :parameters {:query [:map
                             [:identity {:optional true} string?]]}}]

      ["users"
       {:view qsm-users/users-page
        :controllers [qsm-users/controller]
        :name :users
        :parameters {:query ^:replace
                     [:map
                      [:view {:optional true} :string]
                      [:project {:optional true} :string]
                      [:site {:optional true} :string]]}}]

      ["planner"
       {:view planner/page
        :app-nav-page :planner}
       [""
        {:name :planner
         :controllers [planner/list-controller]}]
       ["/new"
        {:name :planner-new-plan
         :controllers [planner/new-plan-controller]}]
       ["/edit/:plan-id"
        {:name :planner-site-plan
         :controllers [planner/plan-controller]
         :parameters {:query [:map
                              [:building-id {:optional true} :string]
                              [:level-id {:optional true} :string]
                              [:background-id {:optional true} :string]
                              [:route-id {:optional true} :string]
                              [:geofence-id {:optional true} :string]
                              [:unit-id {:optional true} :string]
                              [:opening-id {:optional true} :string]
                              [:locator-id {:optional true} :string]
                              [:selected {:optional true} :string]
                              [:action {:optional true} :string]
                              [:image-width {:optional true} :string]
                              [:image-height {:optional true} :string]
                              [:project-id {:optional true} :string]
                              [:site-id {:optional true} :string]]
                      :path  [:map [:plan-id :string]]}}]]

      ["api-docs"
       {:view api-docs/docs-page
        :name :api-docs}]

      ["profile"
       {:view sigin/profile-page
        :name :profile}]

      ;; QPE specific routes, "legacy"
      ["qpe/:qpe-identity"
       {:parameters {:path qpe-path-schema}
        :view qpe/qpe-details
        :conflicting true
        :controllers [qpe/qpe-controller]
        :app-nav-page :qpes}
       [""
        {:name :qpe-info
         :qpe-info-tab :system}]
       ["/info/system"
        {:name :qpe-info-system
         :qpe-details-id :qpe-info
         :qpe-info-tab :system}]
       ["/info/locators"
        {:name :qpe-info-locators
         :qpe-details-id :qpe-info
         :qpe-info-tab :locators
         :parameters {:query peinfo-locators/table-query-params}
         :controllers [qpe/locators-controller]}]
       ["/info/tags"
        {:name :qpe-info-tags
         :qpe-details-id :qpe-info
         :qpe-info-tab :tags
         :parameters {:query peinfo-tags/query-params}
         :controllers [qpe/tag-controller]}]
       ["/info/log"
        {:controllers [peinfo-logs/controller]
         :qpe-info-tab :log}
        [""
         {:name :qpe-info-log
          :qpe-info-tab :log}]
        ["/:log-type"
         {:name :qpe-info-log-type
          ;; Manually merge, as Reitit doesn't yet know how to merge Malli schema.
          :parameters ^:replace {:path (mu/merge qpe-path-schema
                                                 [:map [:log-type :keyword]])}}]]
       ["/info/map"
        {:name :qpe-info-map
         :qpe-details-id :qpe-info
         :qpe-info-tab :map
         :controllers [qpe/tag-controller]
         ;; Manually merge, as Reitit doesn't yet know how to merge Malli schema.
         :parameters {:query (mu/merge mapview-events/query-parameters
                                       peinfo-locators/query-params)}}]
       ["/conf"
        {:name :conf}]
       ["/api"
        {:name :api
         :controllers [api-keys/controller
                       cors/controller]}]
       ["/api-docs"
        {:name :qpe-api-docs
         :controllers []}]]]]
    {:data {:coercion rcm/coercion}}))
